import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os dados
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getDados(cod_ibge) {
  try {
    const { data } = await api.get('/app/pessoas-por-idade/' + cod_ibge)
    return data
  } catch (err) {
    console.log(err)
  }
}

export function generatePdf(cadastros) {
  let title_pdf = 'Calculadora de pessoas'
  let titlePdfSave = utils.methods.titlePdf('Calculadora de pessoas')
  let description_pdf = 'Quantidade de pessoas por idade e equipes de saúde'
  let headers_pdf = ['EQUIPE', 'INE', 'IDADE', 'PESSOAS']
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_equipe = cadastros[i].no_equipe
    obj.ine = cadastros[i].ine
    obj.idade = cadastros[i].idade
    obj.pessoas_idade = cadastros[i].pessoas_idade
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  let rows = []
  for (let i = 0; i < data_pdf.length; i++) {
    rows[i] = Object.values(data_pdf[i])
  }
  let table = []
  for (var i = 0; i < rows.length; i++) {
    var tableRow = rows[i]
    for (var i = 0; i < rows.length; i++) {
      var tableRow = rows[i]
      var rowData = []
      if (tableRow.length != 0) {
        for (var j = 0; j < tableRow.length; j++) {
          rowData.push(tableRow[j])
        }
      } else {
        continue
      }
      table.push(rowData)
    }
  }

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      // Total pessoas
      const totalPessoas = cadastros.reduce(
        (sum, item) => sum + parseInt(item.pessoas_idade),
        0
      )
      doc.setFontSize(12)
      doc.text(
        'Total de pessoas: ' + totalPessoas,
        15,
        verticalPosition,
        null,
        null,
        'left'
      )

      // Data atual
      verticalPosition += 6
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano
      doc.setFontSize(12)
      doc.text(`Data: ${dataAtual}`, 15, verticalPosition, null, null)

      verticalPosition += 6

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
